import React from 'react';

import {
  AcceptedCardBrand,
  getBrandAssetUrlFromBrand,
  getWalletAssetUrlFromWalletType,
} from '../../features/draws/utils/payment-method';
import { GeneratedPaymentMethodCardWallet } from '../../types/generated';

interface CardBrandProps {
  brand: AcceptedCardBrand;
  wallet?: GeneratedPaymentMethodCardWallet | null;
}

export const CardBrand: React.FC<CardBrandProps> = ({ brand, wallet }) => {
  const brandAssetUrl = getBrandAssetUrlFromBrand(brand);
  const walletAssetUrl = getWalletAssetUrlFromWalletType(wallet);

  if (walletAssetUrl) {
    return (
      // eslint-disable-next-line @next/next/no-img-element
      <img
        alt={wallet?.type}
        className="h-5 overflow-hidden"
        src={walletAssetUrl}
      />
    );
  }

  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img alt={brand} className="h-5 overflow-hidden" src={brandAssetUrl} />
  );
};
